export default {
    lang: "希腊语",
    "application": {
        "name": "Σύστημα Δημοσίευσης Πληροφοριών"
    },
    "ajaxTip": {
        "success": "Επιτυχία",
        "error": "Αποτυχία",
        "noAccess": "Δεν έχετε δικαίωμα πρόσβασης σε αυτόν τον πόρο",
        "notFound": "Ο πόρος πρόσβασης δεν υπάρχει",
        "serverBusy": "Ο διακομιστής είναι απασχολημένος",
        "timeOut": "Υπέρβαση χρονικού ορίου"
    },
    "menu": {
        "home": "Αρχική Σελίδα",
        "template": "Διαχείριση Προτύπων",
        "program": "Διαχείριση Προγραμμάτων",
        "playplan": "Πλάνο Αναπαραγωγής",
        "device": "Διαχείριση Συσκευών",
        "source-material": "Διαχείριση Υλικού",
        "material": "Υλικό",
        "checkManage": "Διαχείριση Ελέγχου",
        "setting": "Ρυθμίσεις",
        "usercenter": "Κέντρο Χρήστη",
        "adminManage": "Διαχείριση Συσκευών",
        "schedule": "Εργασίες σε Αναμονή",
        "capitalassets": "Διαχείριση Περιουσιακών Αξιών",
        "modifyPassword": "Τροποποίηση Κωδικού Πρόσβασης",
        "logout": "Αποσύνδεση",
        "add": "Προσθέστε",
        "edit": "Επεξεργαστείτε",
        "delete": "Διαγράψτε",
        "view": "Εμφανίστε",
        "menu_1": "Αρχική σελίδα",
        "menu_2": "Διαχείριση συσκευών",
        "menu_3": "Επεξεργασία (Για προχωρημένους ρυθμίσεις - Βασική επεξεργασία - Αλλαγή δικτύου)",
        "menu_4": "Ακατάλληλοι εντολές",
        "menu_5": "Επεξεργασία (Μεταφορά τμήματος)",
        "menu_6": "Στρατηγική",
        "menu_7": "Ρυθμίσεις όγκου",
        "menu_8": "Ρυθμίσεις φωτεινότητας",
        "menu_9": "Ρυθμίσεις λήψης",
        "menu_10": "Ρυθμίσεις υπνο режиμού",
        "menu_11": "Ιδιότητες συσκευής",
        "menu_12": "Επεξεργασία/Προσθήκη",
        "menu_13": "Διαχείριση προγραμμάτων",
        "menu_14": "Ιστορικό δημοσίευσης",
        "menu_15": "Διαγραφή (Μαζική/Μεμονωμένη)",
        "menu_16": "Πρόγραμματα σε δημοσίευση",
        "menu_17": "Ομαδοποίηση",
        "menu_19": "Λίστα προγραμμάτων",
        "menu_20": "Επεξεργασία περιεχομένου",
        "menu_21": "Αντιγραφή προγράμματος",
        "menu_23": "Δημοσίευση προγράμματος",
        "menu_24": "Διαχείριση υλικών",
        "menu_25": "Μεταφόρτωση",
        "menu_28": "Γρήγορη δημοσίευση",
        "menu_29": "Διαχείριση προτύπων",
        "menu_30": "Δημόσια προτύπα",
        "menu_31": "Χρησιμοποιήστε τώρα",
        "menu_32": "Τα προτύπα μου",
        "menu_33": "Δημοσίευση σε δημόσια προτύπα",
        "menu_35": "Ιστορικό κοινής χρήσης",
        "menu_36": "Διαχείριση Ελέγχου",
        "menu_37": "Έλεγχος προγραμμάτων",
        "menu_38": "Έλεγχος (Έγκριση/Απόρριψη)",
        "menu_39": "Έλεγχος υλικών",
        "menu_41": "Ιστορικό аудίτου (Λειτουργός)",
        "menu_42": "Ιστορικό аудίτου (Έλεγχος)",
        "menu_43": "Εμφάνιση αριθμού εγκρίσεων",
        "menu_44": "Διαχείριση οργανισμού",
        "menu_45": "Διαχείριση αρχείων καταγραφής",
        "menu_46": "Αρχεία καταγραφής αναπαραγωγής",
        "menu_47": "Αρχεία καταγραφής δημοσίευσης",
        "menu_48": "Αρχεία καταγραφής σφαλμάτων",
        "menu_49": "Αρχεία καταγραφής λειτουργιών",
        "menu_50": "Αρχεία καταγραφής αρχείων",
        "menu_51": "Αρχεία καταγραφής σύνδεσης",
        "menu_52": "Έγκριση περιεχομένου",
        "menu_53": "Χώρος αποθήκευσης",
        "menu_54": "Οργανωτική δομή",
        "menu_55": "Δικαιώματα ρόλων",
        "menu_56": "Εξουσιοδότηση",
        "menu_57": "Εμφάνιση (Δικαιώματα εξουσιοδότησης)",
        "menu_58": "Μέλη οργανισμού",
        "menu_60": "Επαναφορά κωδικών πρόσβασης υποτελών χρηστών",
        "menu_61": "Διαχείριση περιουσιακών στοιχείων",
        "menu_62": "Το υπόλοιπό μου",
        "menu_63": "Εμφάνιση (Λεπτομέρειες χρημάτων)",
        "menu_64": "Η χρήση δεδομένων μου",
        "menu_65": "Εμφάνιση (Λεπτομέρειες χρήσης δεδομένων)",
        "menu_66": "Αγορά χρήσης δεδομένων",
        "menu_67": "Η χωρητικότητα μου",
        "menu_68": "Οι συσκευές μου",
        "menu_69": "Λεπτομέρειες παραγγελίας",
        "menu_70": "Εμφάνιση (Επαναφόρτιση)",
        "menu_71": "Εμφάνιση (Αγορασμένα προτύπα)",
        "menu_72": "Εμφάνιση (Αγορασμένη χρήση δεδομένων)",
        "menu_73": "Άλλα δικαιώματα",
        "menu_74": "Εμφάνιση (Στατιστικά υλικών και προγραμμάτων)",
        "menu_75": "Εμφάνιση (Περιουσιακά στοιχεία)",
        "menu_76": "Εμφάνιση (Χώρος σύνδεσης облачных δεδομένων/Στατιστικά)",
        "menu_77": "Εμφάνιση (Στατιστικά συνδεδεμένων συσκευών)"
    },
    "login": {
        "terminalServiceSystem": "Σύστημα Υπηρεσιών Τερματικού",
        "accountLogin": "Σύνδεση με Λογαριασμό",
        "register": "Εγγραφή",
        "accountLoginTip": "Έχετε ήδη λογαριασμό; Συνδεθείτε",
        "scanQRCode": "Συγκεντρώστε τον κώδικα QR",
        "readAndAgree": "Έχω διαβάσει και συμφωνώ",
        "readAndAgreeLink": "Συμφωνία Υπηρεσιών Χρήστη",
        "readAndAgreeAgreement": "Παρακαλούμε διαβάστε και συμφωνήστε με τη Συμφωνία Υπηρεσιών Χρήστη",
        "forgetpassword": "Ξεχάσατε τον κωδικό;",
        "resetpassword": "Επαναφορά Κωδικού Πρόσβασης",
        "phoneEmptyTip": "Παρακαλούμε εισάγετε τον αριθμό κινητού τηλεφώνου",
        "nextStep": "Επόμενο Βήμα",
        "title": "Καλώς ήρθατε στην Σύνδεση",
        "submit": "Σύνδεση",
        "userName": "Λογαριασμός",
        "password": "Κωδικός Πρόσβασης",
        "userNameEmptyTip": "Παρακαλούμε εισάγετε τον λογαριασμό",
        "passwordEmptyTip": "Παρακαλούμε εισάγετε τον κωδικό πρόσβασης",
        "passwordFormatTip": "Παρακαλούμε εισάγετε τον σωστό formato κωδικού πρόσβασης",
        "passwordIsOk": "Παρακαλούμε εισάγετε τον επιβεβαιωτικό κωδικό πρόσβασης",
        "passwordSign": "Παρακαλούμε εισάγετε τον κωδικό πρόσβασης",
        "codeTip": "Παρακαλούμε εισάγετε τον κωδικό επαλήθευσης",
        "phone": "Ο αριθμός κινητού τηλεφώνου δεν μπορεί να είναι κενός",
        "code": "Ο κωδικός επαλήθευσης δεν μπορεί να είναι κενός",
        "nickname": "Το όνομα της εταιρείας δεν μπορεί να είναι κενό",
        "pass": "Ο κωδικός πρόσβασης δεν μπορεί να είναι κενός",
        "pwdMessage": "Ο κωδικός πρόσβασης πρέπει να έχει μήκος 8~20 χαρακτήρες, να μην περιέχει κενά και να περιλαμβάνει τουλάχιστον 3 από τα ακόλουθα: κεφαλαία γράμματα, πεζά γράμματα, αριθμούς, ειδικούς χαρακτήρες",
        "pwdMessage01": "Παρακαλούμε εισάγετε κωδικό πρόσβασης με γράμματα και αριθμούς, τουλάχιστον οκτώ χαρακτήρες",
        "pwdMessage02": "Ο κωδικός πρόσβασης πρέπει να έχει μήκος 8-20 χαρακτήρες",
        "pwdMessage03": "Ο κωδικός πρόσβασης δεν μπορεί να περιέχει κενά",
        "pwdMessage04": "Ο κωδικός πρόσβασης πρέπει να περιλαμβάνει τουλάχιστον τρία από τα ακόλουθα: κεφαλαία γράμματα, πεζά γράμματα, αριθμοί, σύμβολα",
        "newpassempty": "Ο νέος κωδικός πρόσβασης δεν μπορεί να είναι κενός",
        "newpass": "Οι δύο κωδικοί πρόσβασης δεν ταιριάζουν",
        "getcode": "Λήψη Κωδικού Επαλήθευσης",
        "format": "Μη έγκυρο formato αριθμού κινητού τηλεφώνου",
        "chongfa": "Επανάληψη μετά από δευτερόλεπτα",
        "isSend": "Έχει σταλεί",
        "noregister": "Δεν έχετε λογαριασμό; Εγγραφείτε αμέσως",
        "Mobile": "Αριθμός Κινητού Τηλεφώνου",
        "verificationcode": "Κωδικός Επαλήθευσης",
        "petname": "Πευκαστικό όνομα",
        "Quickregistration": "Γρήγορη Εγγραφή",
        "xiugaimima": "Τροποποίηση Κωδικού Πρόσβασης",
        "jiumima": "Παλαιός Κωδικός Πρόσβασης",
        "xinmima": "Νέος Κωδικός Πρόσβασης",
        "zaicishuruxinmima": "Εισαγωγή νέου κωδικού πρόσβασης ξανά",
        "xiugaichenggong": "Τροποποιήθηκε με επιτυχία",
        "xiugaishoujihao": "Τροποποίηση Αριθμού Κινητού Τηλεφώνου",
        "dengluzhanghao": "Λογαριασμός Σύνδεσης",
        "gongsiid": "ID Εταιρείας",
        "yonghunicheng": "Πευκαστικό όνομα Χρήστη",
        "chuangjianshijian": "Χρόνος Δημιουργίας",
        "gongsimingcheng": "Όνομα Εταιρείας",
        "denglumima": "Κωδικός Πρόσβασης Σύνδεσης",
        "jianyi": "Συνιστάται η χρήση κωδικού πρόσβασης με συνδυασμό γραμμάτων και αριθμών",
        "shezhimima": "Ρύθμιση Κωδικού Πρόσβασης",
        "shezhishoujihao": "Τροποποίηση/Ρύθμιση Αριθμού Κινητού Τηλεφώνου",
        "yibangding": "Έχει συνδεθεί",
        "weibangding": "Δεν έχει συνδεθεί",
        "zhanghuanquan": "Ασφάλεια Λογαριασμού",
        "yonghuxinxi": "Πληροφορίες Χρήστη",
        "zhuceSucMsg": "Συγχαρητήρια, η εγγραφή ήταν επιτυχής!",
        "verificationcodeSucMsg": "Ο κωδικός επαλήθευσης στάλθηκε με επιτυχία！",
        "requiredIsEmpty": "Τα υποχρεωτικά πεδία δεν μπορούν να είναι κενά！",
        "emailObj": {
            "title": "Ηλεκτρονική Διεύθυνση",
            "tit": "Σύνδεση με Ηλεκτρονική Διεύθυνση",
            "tip": "Παρακαλούμε εισάγετε την ηλεκτρονική διεύθυνση",
            "formatTip": "Παρακαλούμε εισάγετε την σωστή ηλεκτρονική διεύθυνση"
        },
        "phoneObj": {
            "title": "Αριθμός Κινητού Τηλεφώνου",
            "tit": "Σύνδεση με Αριθμό Κινητού Τηλεφώνου",
            "tip": "Παρακαλούμε εισάγετε τον αριθμό κινητού τηλεφώνου",
            "formatTip": "Παρακαλούμε εισάγετε τον σωστό αριθμό κινητού τηλεφώνου"
        },
        "emailOrPhoneObj": {
            "title": "Ηλεκτρονική Διεύθυνση ή Αριθμός Κινητού Τηλεφώνου",
            "tit": "Σύνδεση με Ηλεκτρονική Διεύθυνση ή Αριθμό Κινητού Τηλεφώνου",
            "tip": "Παρακαλούμε εισάγετε την ηλεκτρονική διεύθυνση ή τον αριθμό κινητού τηλεφώνου",
            "formatTip": "Παρακαλούμε εισάγετε την σωστή ηλεκτρονική διεύθυνση ή αριθμό κινητού τηλεφώνου"
        },
        "wechatObj": {
            "title": "WeChat",
            "tit": "Σύνδεση με WeChat"
        },
        "googleObj": {
            "title": "Google",
            "tit": "Σύνδεση με Google"
        },
        "confirm": "Επιβεβαίωση",
        "confirmSubmit": "Υποβολή Επιβεβαίωσης",
        "cancel": "Ακύρωση",
        "close": "Κλείσιμο",
        "bindSucMsg": "Η σύνδεση ήταν επιτυχής",
        "toContinueBindAccount": "Συνέχισε για να ολοκληρώσεις τη σύνδεση του τρίτου μέρους λογαριασμού",
        "bindTip01": "Δεν έχετε λογαριασμό; Δημιουργήστε έναν",
        "bindTip02": "Έχετε ήδη λογαριασμό",
        "bindTip03": "Ο τρέχων λογαριασμός τρίτου μέρους δεν είναι συνδεδεμένος με τον λογαριασμό της πλατφόρμας. Παρακαλούμε συνδέστε έναν υπάρχον λογαριασμό ή εγγραφείτε και συνδέστε έναν νέο λογαριασμό, για να μπορείτε να συνδεθείτε γρήγορα την επόμενη φορά.",
        "bindTip04": "Σύνδεση υπάρχοντος λογαριασμού",
        "bindTip05": "Εγγραφή και σύνδεση νέου λογαριασμού",
        "bindTip06": "Έχετε εξουσιοδοτήσει μέσω τρίτου μέρους. Συμπληρώστε τις ακόλουθες πληροφορίες σύνδεσης για να ολοκληρώσετε την σύνδεση",
        "bindSubmit": "Υποβολή Σύνδεσης",
        "enterAccountTip": "Παρακαλούμε εισάγετε το όνομα του λογαριασμού",
        "RegisterAndBind": "Εγγραφή και Σύνδεση",
        "loginErr": "Λάθος όνομα χρήστη ή κωδικός πρόσβασης！",
        "usercenter": "Κέντρο Χρήστη",
        "pleaseInputName": "Παρακαλούμε εισάγετε το όνομα",
        "operationSuccess": "Η λειτουργία ήταν επιτυχής！",
        "edit": "Επεξεργασία",
        "xiugai": "Τροποποίηση",
        "userData": "Προσωπικά Στοιχεία",
        "changePassword": "Τροποποίηση Κωδικού Πρόσβασης",
        "account": "Λογαριασμός",
        "userName01": "Όνομα Χρήστη",
        "phoneNumber": "Αριθμός Κινητού Τηλεφώνου",
        "role": "Ρόλος",
        "createTime": "Χρόνος Δημιουργίας",
        "genghuang": "Αντικατάσταση",
        "bangding": "Σύνδεση",
        "unbind": "Αποσύνδεση",
        "plesaseSelectBindingType": "Παρακαλούμε επιλέξτε τον τύπο σύνδεσης",
        "pleaseConfirmCont": "Παρακαλούμε επιβεβαιώστε ότι έχετε διαβάσει αυτό το περιεχόμενο",
        "confirmReadCont": "Έχω διαβάσει αυτό το περιεχόμενο",
        "frequentTip": "Πολλαπλές λειτουργίες, παρακαλούμε προσπαθήστε να το πάρετε αργότερα!",
        "zhuxiaoBtn": "Ακυρώστε τον λογαριασμό",
        "zhuxiaoTitle": "Ακύρωση Λογαριασμού",
        "querenZhuxiao": "Επιβεβαίωση Ακύρωσης",
        "jiXu": "Συνέχεια",
        "sendCodeBtn": "Αποστολή Κωδικού Επαλήθευσης",
        "passwordIsNotOldPassword": "Ο επιβεβαιωτικός κωδικός πρόσβασης διαφέρει από τον νέο κωδικό πρόσβασης",
        "passwordIsOldPassword": "Ο τροποποιημένος κωδικός πρόσβασης είναι ο ίδιος με τον παλαιό κωδικό πρόσβασης",
        "passFormatError": "Παρακαλούμε εισάγετε τον σωστό formato κωδικού πρόσβασης",
        "oldPassWord": "Παλαιός Κωδικός Πρόσβασης",
        "newPassWord": "Νέος Κωδικός Πρόσβασης",
        "inputPlaceholder": "Παρακαλούμε εισάγετε",
        "confirmPassword": "Επιβεβαιωτικός Κωδικός Πρόσβασης",
        "zhuxiaoTip": `
            1、Η ακύρωση λογαριασμού είναι μια μη αναστρέψιμη λειτουργία. Μόλις ακυρωθεί ο λογαριασμός, δεν θα μπορείτε να συνδεθείτε και να χρησιμοποιήσετε αυτόν τον λογαριασμό ή τρίτους λογαριασμούς που έχουν εγγραφεί και συνδεθεί μέσω αυτού του λογαριασμού. Παρακαλούμε δημιουργήστε αντίγραφα ασφαλείας των σχετικών πληροφοριών και δεδομένων του λογαριασμού. 
            2、Πριν από την εγγραφή αυτού του λογαριασμού, βεβαιωθείτε ότι έχετε καθαρίσει όλη την περιουσία κ.λπ. και δεν υπάρχουν κανένα διαφωνία. Μόλις ακυρωθεί αυτός ο λογαριασμός, θεωρείται ότι εγκαταλείπετε την ιδιοκτησία όλων των περιουσιακών στοιχείων και δικαιωμάτων σε αυτόν τον λογαριασμό, και δεν μπορεί να ανακτηθεί ή ανακτηθεί. 
            3、Εάν ο αριθμός κινητού τηλεφώνου που χρησιμοποιείται για την εγγραφή του ίδιου λογαριασμού ακυρώνεται συνολικά 3 φορές, ο αριθμός κινητού τηλεφώνου δεν μπορεί να χρησιμοποιηθεί για την εγγραφή νέου λογαριασμού και δεν μπορεί να συνδεθεί με οποιονδήποτε άλλον λογαριασμό.
        `
    },
    "home": {
        "title": "Αρχική Σελίδα",
        "quickOperation": "Γρήγορες Λειτουργίες",
        "addDevice": "Προσθήκη Συσκευής",
        "publishProgram": "Δημοσίευση Προγράμματος",
        "publishMaterial": "Δημοσίευση Υλικού",
        "makeProgram": "Δημιουργία Προγράμματος",
        "uploadMaterial": "Ανέβασμα Υλικού",
        "todayData": "Σήμερα Δεδομένα (ενημερώνεται κάθε ώρα)",
        "playNumChart": "Στατιστικά Αριθμού Αναπαραγωγών",
        "deviceOnlineStatus": "Κατάσταση Εντός Δικτύου Συσκευής",
        "onLineDevice": "Συσκευές Εντός Δικτύου",
        "unLineDevice": "Συσκευές Εκτός Δικτύου",
        "programPlayTime": "Στατιστικά Διαρκείας Αναπαραγωγής Προγράμματος",
        "downloadSoft": "Λήψη Λογισμικού",
        "adminApp": "Μобιλное приложение пользователя",
        "playerApp": "Τερματικό Αναπαραγωγής Δημοσίευσης Πληροφοριών",
        "downloadAdminApp": "Κάντε κλικ για να κατεβάσετε την εφαρμογή χρήστη",
        "downloadPlayerApp": "Κάντε κλικ για να κατεβάσετε το τερματικό αναπαραγωγής",
        "aboutUs": "Για Εμάς",
        "userManual": "Εγχειρίδιο Χρήστη",
        "message": "Θέλω να αφήσω ένα μήνυμα"
    },
    "device": {
        "inputPlaceholder": "Παρακαλούμε εισάγετε",
        "selectPlaceholder": "Παρακαλούμε επιλέξτε",
        "osTypeStr": "Σύστημα Τερματικού",
        "onLineStatus": "Κατάσταση Εντός Δικτύου",
        "dpi": "Ανάλυση",
        "companyDeptIdName": "Αποκαλύπτεται Υποκατάστημα",
        "deviceGroupIdName": "Αποκαλύπτεται Ομάδα",
        "editOrMove": "Επεξεργασία/Μετακίνηση",
        "loanOriginationFee": "Τέλη Έκδοσης Δανείου",
        "strategyInfoLook": "Εμφάνιση Πληροφοριών Στρατηγικής",
        "programLook": "Εμφάνιση Προγράμματος",
        "addEquipments": "Προσθήκη Συσκευών",
        "luminanceSet": "Έλεγχος Φωτεινότητας",
        "terminal": "Ρυθμίσεις Τερματικού",
        "transferCompany": "Μεταφορά Τμήματος",
        "releasedProgram": "Δημοσίευση Προγράμματος",
        "screenshot": "Λήψη Οθόνης",
        "changeGroup": "Αλλαγή Ομάδας",
        "defaultGroup": "Προεπιλεγμένη Ομάδα",
        "operation": "Λειτουργία",
        "edit": "Επεξεργασία",
        "saveEdit": "Αποθήκευση Επεξεργασίας",
        "add": "Προσθήκη",
        "save": "Αποθήκευση",
        "setting": "Ρυθμίσεις",
        "program": "Πρόγραμμα",
        "unbind": "Αποσύνδεση",
        "sleep": "Κατάσταση Καθεύδωσης",
        "wakeup": "Ξύπνισμα",
        "restart": "Επανεκκίνηση",
        "shutdown": "Κλείσιμο",
        "reportLog": "Αναφορά Καταγραφής",
        "clearPlayData": "Καθαρισμός Δεδομένων Τερματικού Αναπαραγωγής",
        "offlineWarn": "Αυτή η συσκευή είναι εκτός δικτύου, παρακαλούμε προσπαθήστε ξανά όταν η συσκευή είναι εντός δικτύου！",
        "confirmUnbind": "Επιβεβαίωση Αποσύνδεσης",
        "confirmReset": "Επιβεβαίωση Καθαρισμού",
        "confirmDelete": "Επιβεβαίωση Διαγραφής",
        "delete": "Διαγραφή",
        "cancelDelete": "Ακύρωση Διαγραφής",
        "confirmResetSuccess": "Καθαρισμός Επιτυχής",
        "confirm": "Επιβεβαίωση",
        "cancel": "Ακύρωση",
        "operationSuccess": "Λειτουργία Επιτυχής",
        "unbindSuccess": "Αποσύνδεση Επιτυχής",
        "pleaseSelectDevice": "Παρακαλούμε επιλέξτε συσκευή",
        "pleaseSelectOnlineDevice": "Παρακαλούμε επιλέξτε συσκευή εντός δικτύου",
        "confirmMixOperation": "Οι επιλεγμένες συσκευές περιλαμβάνουν συσκευές εκτός δικτύου, αυτή η ρύθμιση δεν ισχύει για συσκευές εκτός δικτύου, επιβεβαιώστε τη συνέχιση της λειτουργίας；",
        "pleaseSelectDate": "Παρακαλούμε επιλέξτε ημερομηνία",
        "reportSuccess": "Αναφορά Επιτυχής",
        "deviceSetting": "Ρυθμίσεις Συσκευής",
        "default": "Προεπιλογή",
        "all": "Όλες",
        "deviceList": "Λίστα Συσκευών",
        "addDevice": "Προσθήκη Συσκευής",
        "department": "Τμήμα/Οργανισμός",
        "deviceType": "Ανάλυση",
        "osType": "Σύστημα Τερματικού",
        "onlineState": "Κατάσταση Εντός Δικτύου",
        "online": "Εντός Δικτύου",
        "offline": "Εκτός Δικτύου",
        "notActive": "Μη Ενεργοποιημένο",
        "search": "Παρακαλούμε εισάγετε λέξεις-κλειδιά",
        "batchOperation": "Μαζική Λειτουργία",
        "allDevices": "Όλες οι Συσκευές",
        "deviceAttribute": "Χαρακτηριστικά Συσκευής",
        "selectReportDate": "Επιλογή Ημερομηνίας Αναφοράς",
        "inputName": "Παρακαλούμε εισάγετε το όνομα",
        "inputWidth": "Παρακαλούμε εισάγετε το πλάτος",
        "inputHeight": "Παρακαλούμε εισάγετε το ύψος",
        "inputResolutionRatio": "Παρακαλούμε εισάγετε ακέραιο αριθμό μεγαλύτερο από 0！",
        "inputSort": "Παρακαλούμε εισάγετε ταξινόμηση",
        "serialNum": "Αριθμός Σειράς",
        "name": "Όνομα",
        "width": "Πλάτος",
        "height": "Ύψος",
        "resolutionRatio": "Ανάλυση",
        "inputResolutionRatioName": "Παρακαλούμε εισάγετε το όνομα ανάλυσης",
        "sort": "Ταξινόμηση",
        "personal": "Προσωπικό",
        "system": "Σύστημα",
        "type": "Τύπος",
        "systemDefaultSettingUneditable": "Οι προεπιλεγμένες ρυθμίσεις του συστήματος δεν μπορούν να επεξεργαστούν!",
        "systemDefaultSettingUnDeletable": "Οι προεπιλεγμένες ρυθμίσεις του συστήματος δεν μπορούν να διαγραφούν!",
        "newz": "Νέο",
        "total": "Σύνολο",
        "totalNum": "αρτήματα",
        "strategyName": "Όνομα Στρατηγικής",
        "associatedTerminalNum": "Αριθμός Συνδεδεμένων Τερματικών",
        "createTime": "Χρόνος Δημιουργίας",
        "pleaseSelectStrategy": "Παρακαλούμε επιλέξτε στρατηγική！",
        "onlySelectOneData": "Μπορείτε να επιλέξετε μόνο ένα δεδομένο！",
        "downloadStrategy": "Λήψη Στρατηγικής",
        "inputStrategyName": "Παρακαλούμε εισάγετε το όνομα της στρατηγικής",
        "luminanceControl": "Έλεγχος Φωτεινότητας",
        "volumeStrategy": "Στρατηγική Όγκου",
        "saveSuccess": "Αποθήκευση Επιτυχής",
        "screenAngle": "Περιστροφή Οθόνης (°)",
        "startTime": "Ώρα Έναρξης",
        "endTime": "Ώρα Λήξης",
        "repeat": "Επανάληψη",
        "monday": "Δευτέρα",
        "tuesday": "Τρίτη",
        "wednesday": "Τετάρτη",
        "thursday": "Πέμπτη",
        "friday": "Παρασκευή",
        "saturday": "Σάββατο",
        "sunday": "Κυριακή",
        "everyday": "Κάθε μέρα",
        "downloadSpeed": "Ταχύτητα Λήψης",
        "inputDownloadSpeed": "Παρακαλούμε εισάγετε την ταχύτητα λήψης",
        "operator": "Λειτουργία",
        "pleaseSelectDeleteData": "Παρακαλούμε επιλέξτε τα δεδομένα προς διαγραφή！",
        "confirmBatchDelete": "Επιβεβαίωση μαζικής διαγραφής;",
        "pleaseInputName": "Παρακαλούμε εισάγετε το όνομα",
        "detailSetting": "Λεπτομερείς Ρυθμίσεις",
        "weekPlan": "Εβδομαδιαίο Πλάνο",
        "specialDateSetting": "Ρυθμίσεις Ειδικής Ημερομηνίας",
        "weekdayInfo": "Η ημέρα της εβδομάδας είναι υποχρεωτική!",
        "volumeInfo": "Ο όγκος είναι υποχρεωτικός!",
        "timeError": "Λάθος επιλογή ώρας!",
        "editSuccess": "Η επεξεργασία ήταν επιτυχής！",
        "addSuccess": "Η προσθήκη ήταν επιτυχής！",
        "addSpecialPlan": "Προσθήκη Ειδικού Πλάνου Στρατηγικής",
        "downloadSpeedInfo": "Ταχύτητα Λήψης:(0 σημαίνει απαγόρευση λήψης)",
        "pleaseSelectStartTime": "Παρακαλούμε επιλέξτε ώρα έναρξης",
        "pleaseSelectEndTime": "Παρακαλούμε επιλέξτε ώρα λήξης",
        "luminanceError": "Παρακαλούμε εισάγετε την σωστή τιμή φωτεινότητας！",
        "defaultLuminance": "Προεπιλεγμένη Φωτεινότητα",
        "luminance": "Μέγεθος Φωτεινότητας",
        "defaultLuminanceInfo": "Προεπιλεγμένη Φωτεινότητα (100 σημαίνει το πιο φωτεινό, 0 σημαίνει το πιο σκοτεινό)",
        "volume": "Όγκος",
        "saveLuminance": "Αποθήκευση Φωτεινότητας",
        "changeSuccess": "Η αλλαγή ήταν επιτυχής！",
        "changeNetwork": "Αλλαγή Δικτύου",
        "netName": "Όνομα Δικτύου",
        "nameempty": "Το όνομα του δικτύου δεν μπορεί να είναι κενό",
        "currentNetwork": "Τρέχον Δίκτυο",
        "ipAddress": "Διεύθυνση IP",
        "dailyMode": "Καθημερινό Λειτουργικό Μόδιο",
        "weeklyMode": "Εβδομαδιαίο Λειτουργικό Μόδιο",
        "turnOnTime": "Ώρα Ενεργοποίησης",
        "turnOffTime": "Ώρα Κατασχείου",
        "startSleep": "Έναρξη Καθεύδωσης",
        "endSleep": "Λήξη Καθεύδωσης",
        "batchDelInfo": "Επιβεβαίωση διαγραφής επιλεγμένων στοιχείων;",
        "timeCannotBeEmpty": "Η ώρα δεν μπορεί να είναι κενή!",
        "startUp": "Ενεργοποίηση",
        "shutDown": "Κλείσιμο",
        "volumeSize": "Μέγεθος Όγκου",
        "defaultVolume": "Προεπιλεγμένος Όγκος (100 σημαίνει το μέγιστο, 0 σημαίνει ήχου μηδέν)",
        "chooseStartTime": "Παρακαλούμε επιλέξτε ώρα έναρξης",
        "chooseEndTime": "Παρακαλούμε επιλέξτε ώρα λήξης",
        "saveVolume": "Αποθήκευση Όγκου",
        "screenRotationUnSaved": "Η περιστροφή της οθόνης δεν έχει αποθηκευτεί",
        "volumeSettingUnSaved": "Οι ρυθμίσεις όγκου δεν έχουν αποθηκευτεί",
        "luminanceSettingUnSaved": "Οι ρυθμίσεις φωτεινότητας δεν έχουν αποθηκευτεί",
        "confirmClosePopup": "Επιβεβαίωση κλεισίματος αυτού του αναδυόμενου παραθύρου;",
        "volumeSettingSuccess": "Η τροποποίηση του όγκου ήταν επιτυχής",
        "luminanceSettingSuccess": "Η τροποποίηση της φωτεινότητας ήταν επιτυχής",
        "advancedSettingUnSaved": "Οι προηγμένες ρυθμίσεις δεν έχουν αποθηκευτεί",
        "settingTitle": "Ρυθμίσεις Τερματικού",
        "volumeSetting": "Ρυθμίσεις Όγκου",
        "luminanceSetting": "Ρυθμίσεις Φωτεινότητας",
        "downloadSetting": "Ρυθμίσεις Λήψης",
        "sleepSetting": "Ρυθμίσεις Καθεύδωσης",
        "onOffSetting": "Προγραμματισμένη Ενεργοποίηση/Κλείσιμο",
        "screenRotation": "Περιστροφή Οθόνης",
        "namingError": "Λάθος ονομασία, το όνομα του αρχείου δεν μπορεί να περιέχει κενά！",
        "deleteSuccess": "Διαγραφή Επιτυχής",
        "deleteFolder": "Διαγραφή Φάκελου",
        "pleaseInputDeviceName": "Παρακαλούμε εισάγετε το όνομα της συσκευής",
        "pleaseInputDeviceId": "Παρακαλούμε εισάγετε το ID της συσκευής",
        "discoverDevice": "Εύρεση Συσκευής",
        "deviceId": "ID Συσκευής",
        "bound": "Έχει συνδεθεί",
        "bind": "Σύνδεση",
        "noDevice": "Καμία συσκευή",
        "refresh": "Ανανέωση",
        "manualAdd": "Εχειροκίνητη Προσθήκη",
        "deviceGroup": "Κατηγοριοποίηση Συσκευών",
        "pleaseSelectGroup": "Παρακαλούμε επιλέξτε ομάδα！",
        "deviceName": "Όνομα Συσκευής",
        "goAdd": "Μεταφορά στην προσθήκη",
        "close": "Κλείσιμο",
        "bindCountInsufficient": "Αδυναμία επαρκούς αριθμού σύνδεσης, παρακαλούμε αναβαθμίστε τον αριθμό συσκευών και στη συνέχεια προσθέστε！",
        "displayNumber": "Αριθμός Εμφάνισης",
        "groupName": "Όνομα Ομάδας",
        "pleaseSelectGroupName": "Παρακαλούμε συμπληρώστε το όνομα της ομάδας！",
        "moveGroup": "Μετακίνηση Ομάδας",
        "longitude": "Γεωγραφικό μήκος",
        "latitude": "Γεωγραφικό πλάτος",
        "nationality": "Εθνικότητα",
        "province": "Περιφέρεια",
        "city": "Πόλη",
        "county": "Νομός",
        "outNetIp": "Διαδικτυακή IP",
        "inNetIp": "Εσωδικτυακή IP",
        "companyName": "Όνομα Επιχείρησης",
        "Info": "Λεπτομέρειες",
        "android": "Android",
        "win": "Windows",
        "osVersion": "Έκδοση Συστήματος",
        "softwareVersion": "Έκδοση Λογισμικού",
        "diskSize": "Μέγεθος Δίσκου",
        "useSize": "Χρησιμοποιημένο Μέγεθος",
        "macAddr": "Διεύθυνση MAC",
        "longitudeLatitudeInfo": "Το γεωγραφικό μήκος και το γεωγραφικό πλάτος πρέπει να είναι ταυτόχρονα κενά ή μη κενά!",
        "terminalName": "Όνομα Τερματικού",
        "terminalGroup": "Ομάδα Τερματικών",
        "reportJournal": "Είναι αναφορά",
        "systemVersion": "Έκδοση Συστήματος",
        "storageSpace": "Χώρος Αποθήκευσης",
        "resolution": "Ανάλυση",
        "runningMemory": "Εκτελούμενη Μνήμη",
        "model": "Μοντέλο",
        "registerStatus": "Κατάσταση Εγγραφής",
        "password": "Κωδικός Πρόσβασης",
        "passwordInfo": "Παρακαλούμε εισάγετε λέξη ή αριθμό από 6 έως 18 χαρακτήρες!",
        "group": "Ομάδα",
        "address": "Διεύθυνση",
        "remark": "Σημείωση",
        "renewalPeriod": "Περίοδος Ανανέωσης",
        "money": "Τέλη",
        "latitudeInfo": "Παρακαλούμε εισάγετε την σωστή γεωγραφικό πλάτος!",
        "totalPayment": "Συνολική Πληρωμή",
        "longitudeInfo": "Παρακαλούμε εισάγετε την σωστή γεωγραφικό μήκος!",
        "setMeal": "Πακέτο",
        "number": "Αριθμός",
        "programName": "Όνομα Προγράμματος",
        "playStatus": "Κατάσταση Αναπαραγωγής",
        "playType": "Τρόπος Αναπαραγωγής",
        "play": "Αναπαραγωγή",
        "pause": "Παύση",
        "playTime": "Ώρα Αναπαραγωγής",
        "programDeleted": "Το πρόγραμμα έχει διαγραφεί",
        "playSuccess": "Το πρόγραμμα έχει προγραμματιστεί για αναπαραγωγή",
        "pauseSuccess": "Η παύση ήταν επιτυχής",
        "playCycle": "Επαναληπτική Αναπαραγωγή",
        "playInsert": "Εισαγωγή Αναπαραγωγής",
        "withdrawSuccess": "Η ανάκληση ήταν επιτυχής",
        "withdrawInfo": "Παρακαλούμε πρώτα επιλέξτε το πρόγραμμα προς ανάκληση！",
        "programBelong": "Αποκαλύπτεται Πρόγραμμα",
        "checkAll": "Επιλογή Όλων",
        "batchDel": "Μαζική Διαγραφή",
        "delConfirm": "Επιβεβαίωση διαγραφής επιλεγμένων στοιχείων;",
        "check": "Επιλεγμένο",
        "noProgram": "Καμία πρόγραμμα",
        "details": "Λεπτομέρειες",
        "screenshotFail": "Αποτυχία Λήψης Οθόνης",
        "policyName": "Όνομα Πολιτικής",
        "terminalNum": "Αριθμός Συνδεδεμένων Τερματικών",
        "powerStrategy": "Στρατηγική Τροφοδοσίας",
        "pleaseSelectDepartment": "Παρακαλούμε επιλέξτε τμήμα！",
        "screenshotControl": "Έλεγχος Λήψης Οθόνης",
        "未激活": "Μη Ενεργοποιημένο",
        "已激活": "Ενεργοποιημένο",
        "未绑定": "Μη Συνδεδεμένο",
        "已绑定": "Συνδεδεμένο"
    },
    "programManage": {
        "programList": "Λίστα Προγραμμάτων",
        "publishProgram": "Ιστορική Δημοσίευσης Προγράμματος",
        "week1": "Δευτέρα",
        "week2": "Τρίτη",
        "week3": "Τετάρτη",
        "week4": "Πέμπτη",
        "week5": "Παρασκευή",
        "week6": "Σάββατο",
        "week7": "Κυριακή",
        "monday": "Δευτέρα",
        "tuesday": "Τρίτη",
        "wednesday": "Τετάρτη",
        "thursday": "Πέμπτη",
        "friday": "Παρασκευή",
        "saturday": "Σάββατο",
        "sunday": "Κυριακή",
        "name": "Όνομα",
        "preview": "Προεπισκόπηση",
        "playDeviceNum": "Αριθμός Συσκευών Αναπαραγωγής",
        "copyDeviceCode": "Κάντε κλικ για αντιγραφή",
        "osType": "Τύπος Συστήματος",
        "playDate": "Ημερομηνία Αναπαραγωγής",
        "playWeek": "Εβδομάδα Αναπαραγωγής",
        "everyday": "Κάθε μέρα",
        "start": "Από",
        "end": "Έως",
        "playOperateStatusStr": "Κατάσταση Δημοσίευσης",
        "playDevice": "Συσκευή Αναπαραγωγής",
        "downloadView": "Εμφάνιση Λήψης",
        "publisher": "Δημοσιεύων",
        "publishTime": "Ώρα Δημοσίευσης",
        "operation": "Λειτουργία",
        "add": "Προσθήκη",
        "groupName": "Όνομα Ομάδας",
        "selectDevice": "Επιλογή Τερματικού",
        "searchDevice": "Αναζήτηση Τερματικού",
        "pleaseFillGroupName": "Παρακαλούμε συμπληρώστε το όνομα της ομάδας！",
        "remarkInfo": "Σημείωση",
        "compile": "Επεξεργασία",
        "withdrawConfirm": "Επιβεβαίωση ανάκλησης αυτού του προγράμματος;",
        "confirm": "Επιβεβαίωση",
        "cancel": "Ακύρωση",
        "withdraw": "Ανάκληση",
        "batchWithdraw": "Μαζική Ανάκληση",
        "batchPublish": "Μαζική Δημοσίευση",
        "batchDelete": "Μαζική Διαγραφή",
        "batchOperation": "Μαζική Λειτουργία",
        "notUse": "Μη Χρησιμοποιούμενο",
        "notChecked": "Μη Ελεγχόμενο",
        "notPass": "Μη Επιβεβαιωμένο",
        "delete": "Διαγραφή",
        "publishTextLeft": "Έχει δημοσιευτεί",
        "offTextLeft": "Έχει παύσει",
        "pleaseSelectProgramToMove": "Παρακαλούμε επιλέξτε το πρόγραμμα προς μεταφορά！",
        "pause": "Παύση",
        "pauseConfirm": "Επιβεβαίωση παύσης;",
        "play": "Αναπαραγωγή",
        "downloadUdisk": "Λήψη USB Δίσκου",
        "deviceList": "Λίστα Συσκευών",
        "groupSelection": "Επιλογή Ομάδας",
        "operationSuccess": "Λειτουργία Επιτυχής",
        "deleteSuccess": "Διαγραφή Επιτυχής",
        "selectDate": "Επιλογή Ημερομηνίας",
        "publishStatus": "Κατάσταση Δημοσίευσης",
        "checkStatus": "Κατάσταση Ελέγχου",
        "waitAuditing": "Σε Αναμονή Ελέγχου",
        "auditPass": "Έχει περάσει τον έλεγχο",
        "auditRefuse": "Απόρριψη Ελέγχου",
        "all": "Όλες",
        "playStatus": "Κατάσταση Αναπαραγωγής",
        "playStatust": "Κατάσταση Αναπαραγωγής",
        "pauseStatus": "Έχει παύσει",
        "notStartStatus": "Μη Έναρξη",
        "resolutionratio": "Ανάλυση",
        "totalNum": "αρτήματα",
        "programName": "Όνομα Προγράμματος",
        "playStartTime": "Ώρα Έναρξης Αναπαραγωγής",
        "playEndTime": "Ώρα Λήξης Αναπαραγωγής",
        "createTime": "Χρόνος Δημιουργίας",
        "nationality": "Εθνικότητα",
        "province": "Περιφέρεια",
        "city": "Πόλη",
        "county": "Νομός",
        "address": "Διεύθυνση",
        "ip": "Διεύθυνση IP",
        "location": "Τοποθεσία",
        "log": "Καταγραφή",
        "pleaseFillProgramName": "Παρακαλούμε συμπληρώστε το όνομα του προγράμματος！",
        "selectGroup": "Επιλογή Ομάδας",
        "startTime": "Ώρα Έναρξης",
        "endTime": "Ώρα Λήξης",
        "publishCycle": "Κύκλος Δημοσίευσης",
        "publishDeviceNum": "Αριθμός Συσκευών Δημοσίευσης",
        "pleaseSelectRecord": "Παρακαλούμε επιλέξτε καταγραφή",
        "deviceName": "Όνομα Τερματικού",
        "deviceId": "ID Συσκευής Τερματικού",
        "deviceGroupIdName": "Αποκαλύπτεται Ομάδα",
        "notClassified": "Μη Κατηγοριοποιημένο",
        "osTypeStr": "Σύστημα Τερματικού",
        "storageSpace": "Χώρος Αποθήκευσης",
        "onLineStatus": "Κατάσταση Εντός Δικτύου",
        "onLine": "Εντός Δικτύου",
        "offLine": "Εκτός Δικτύου",
        "sleep": "Καθεύδωση",
        "unknown": "Άγνωστο",
        "registerStatus": "Κατάσταση Εγγραφής",
        "trialPeriod": "Περίοδος Δοκιμής",
        "notActive": "Μη Ενεργοποιημένο",
        "active": "Ενεργοποιημένο",
        "parameterError": "Λάθος παράμετροι!",
        "pleaseSelectProgram": "Παρακαλούμε επιλέξτε πρόγραμμα!",
        "pleaseSelectProgramEdit": "Παρακαλούμε επιλέξτε το πρόγραμμα προς επεξεργασία!",
        "confirmWithdrawSelectedProgram": "Επιβεβαίωση ανάκλησης επιλεγμένων προγραμμάτων;",
        "withdrawSuccess": "Η ανάκληση ήταν επιτυχής",
        "allPrograms": "Όλα τα Προγράμματα",
        "defaultGroup": "Προεπιλεγμένη Ομάδα",
        "cannotShareEmptyProgram": "Αδυναμία κοινής χρήσης κενού προγράμματος！",
        "onlyShareYourProgram": "Μπορείτε να μοιραστείτε μόνο τα προγράμματα που έχετε δημιουργήσει!",
        "pleaseSelectProgramEditPublishTime": "Παρακαλούμε επιλέξτε το πρόγραμμα με επεξεργασμένη ώρα δημοσίευσης!",
        "pleaseSelectDevice": "Παρακαλούμε επιλέξτε συσκευή!",
        "programDetail": "Λεπτομέρειες Προγράμματος",
        "errorReason": "Αιτία Σφάλματος",
        "availableStorageSpaceInsufficient": "Μη επαρκής διαθέσιμος χώρος αποθήκευσης",
        "partialDeviceReleaseFailure": "Αποτυχία δημοσίευσης σε μερικές συσκευές",
        "allDeviceReleaseSuccess": "Η δημοσίευση σε όλες τις συσκευές ήταν επιτυχής",
        "partialDeviceReleaseSuccess": "Η δημοσίευση σε μερικές συσκευές ήταν επιτυχής",
        "allGroup": "Όλες οι Ομάδες",
        "allProgram": "Όλα τα Προγράμματα",
        "unGrouped": "Μη Ομαδοποιημένο",
        "replaceProgram": "Αντικατάσταση Προγράμματος",
        "replaceProgramTip": "Το πρόσφατα δημοσιευμένο πρόγραμμα θα αντικαταστήσει τα υπάρχοντα δεδομένα προγράμματος που έχουν αποστέλλει στο τερματικό αναπαραγωγής！",
        "screen": "Μονό/Διπλή Οθόνη",
        "singleScreen": "Μονό Οθόνη",
        "doubleScreen": "Διπλή Οθόνη",
        "playSetting": "Ρυθμίσεις Αναπαραγωγής",
        "batchPlaySetting": "Μαζική Ρύθμιση Ώρας Αναπαραγωγής",
        "individualPlaySetting": "Ατομική Ρύθμιση Ώρας Αναπαραγωγής",
        "playTime": "Ώρα Αναπαραγωγής",
        "daily": "Κάθε μέρα",
        "weekdays": "Δευτέρα έως Παρασκευή",
        "monthly": "Τρέχον μήνα",
        "advancedSetting": "Προηγμένες Ρυθμίσεις",
        "playProgram": "Αναπαραγωγή Προγράμματος",
        "searchProgram": "Παρακαλούμε εισάγετε λέξεις-κλειδιά",
        "shareAddressNotExist": "Η διεύθυνση κοινής χρήσης δεν υπάρχει, παρακαλούμε προσπαθήστε ξανά",
        "copySuccess": "Η αντιγραφή ήταν επιτυχής",
        "shareLink": "Σύνδεσμος Κοινής Χρήσης",
        "publish": "Δημοσίευση",
        "noResource": "Καμία πόρος",
        "single": "Μονό Οθόνη",
        "double": "Διπλή Οθόνη",
        "time": "Ώρα",
        "associatedTerminalNum": "Αριθμός Συνδεδεμένων Τερματικών",
        "default": "Προεπιλογή",
        "moveGroup": "Μετακίνηση Ομάδας",
        "pleaseSelectGroup": "Παρακαλούμε συμπληρώστε το όνομα της ομάδας！",
        "copy": "Αντιγραφή",
        "FUBEN": "Αντίγραφο",
        "nameempty": "Το όνομα δεν μπορεί να είναι κενό",
        "whitespace": "Λάθος ονομασία, το όνομα του αρχείου δεν μπορεί να περιέχει κενά！",
        "programWhitespace": "Λάθος ονομασία, το όνομα του προγράμματος δεν μπορεί να περιέχει κενά！",
        "pleaseSelectResolution": "Παρακαλούμε επιλέξτε ανάλυση！",
        "dataError": "Λάθος δεδομένων！",
        "createProgram": "Δημιουργία Νέου Προγράμματος",
        "directCreate": "Άμεση Δημιουργία",
        "myTemplate": "Τα Προτύπατά Μου",
        "use": "Χρήση",
        "free": "Δωρεάν",
        "loadMore": "Φόρτωση Περισσότερων",
        "confirmDelete": "Επιβεβαίωση Διαγραφής",
        "deleteGroup": "Διαγραφή Ομάδας",
        "notPublished": "Μη Δημοσιευμένο",
        "notPassed": "Μη Επιβεβαιωμένο",
        "notUsed": "Μη Χρησιμοποιούμενο",
        "confirmDeleteSelectedProgram": "Επιβεβαίωση διαγραφής επιλεγμένων προγραμμάτων;",
        "companyName": "Όνομα Επιχείρησης",
        "programCannotDownload": "Αυτό το πρόγραμμα δεν μπορεί να κατεβεί！",
        "publishMaterial": "Δημοσίευση Υλικού",
        "playMaterial": "Αναπαραγωγή Υλικού",
        "pleaseInputMaterialName": "Παρακαλούμε εισάγετε το όνομα του υλικού",
        "size": "Μέγεθος",
        "pleaseInputDeviceName": "Παρακαλούμε εισάγετε το όνομα της συσκευής",
        "item": "αρτήματα",
        "allMaterial": "Όλο το Υλικό",
        "allDevices": "Όλες οι Συσκευές",
        "saveSuccess": "Αποθηκεύτηκε επιτυχώς",
        "savefaill": "Αποτυχία αποθήκευσης",
        "playMode": "Λειτουργία αναπαραγωγής",
        "cyclePlay": "Κυκλική αναπαραγωγή",
        "insertPlay": "Εισαγόμενη αναπαραγωγή",
        "noData": "Δεν υπάρχουν δεδομένα",
        "Add": "Προσθήκη",
        "replace": "Αντικατάσταση",
        "repeat": "Επανάληψη",
        "start01": "Έναρξη",
        "end01": "Τέλος",
        "startDate": "Ημερομηνία έναρξης",
        "endDate": "Ημερομηνία λήξης",
        "useNow": "Χρήση αμέσως",
        "fillStartEndTimeFirst": "Παρακαλούμε συμπληρώστε πρώτα την ώρα έναρξης και λήξης πριν προσθέσετε",
        "fillFullPlayTime": "Παρακαλούμε συμπληρώστε την πλήρη διάρκεια αναπαραγωγής",
        "fillCorrectPlayTime": "Παρακαλούμε συμπληρώστε τη σωστή περίοδο αναπαραγωγής",
        "sDateAndEDateBothEmptyOrFilled": "Η ημερομηνία έναρξης και η ημερομηνία λήξης πρέπει να είναι και οι δύο κενές ή και οι δύο συμπληρωμένες"
    },
    "source": {
        "addResource": "Προσθήκη Πόρου",
        "width": "Πλάτος",
        "height": "Ύψος",
        "size": "Μέγεθος (KB)",
        "name": "Όνομα",
        "pleaseInputResourceName": "Παρακαλούμε εισάγετε το όνομα του πόρου！",
        "addToGroup": "Προσθήκη σε Ομάδα",
        "remark": "Σημείωση",
        "promptFgIllustrate": "Ιλούστραση",
        "promptFgRealisticPhoto": "Ρεαλιστική Φωτογραφία",
        "promptFgSimplisticDrawing": "Απλή Ζωγραφική",
        "promptFgChineseStyle": "Κινέζικο Στυλ",
        "promptFgPixelArt": "Pixel Art",
        "noModel": "Καμία μοντέλο, παρακαλούμε επικοινωνήστε με τον διαχειριστή！",
        "getModelFailed": "Αποτυχία λήψης μοντέλου, παρακαλούμε προσπαθήστε ξανά αργότερα！ή επικοινωνήστε με τον διαχειριστή！",
        "createImagePrompt": "Γεννιέται εικόνα, παρακαλούμε κλείστε αργότερα！",
        "promptEmpty": "Παρακαλούμε εισάγετε προτροπή",
        "dpiEmpty": "Παρακαλούμε επιλέξτε tỷπο εικόνας！",
        "fgEmpty": "Παρακαλούμε επιλέξτε στυλ！",
        "style": "Στυλ",
        "idEmpty": "Το ID της εικόνας δεν μπορεί να είναι κενό",
        "exist": "Αυτή η εικόνα υπάρχει ήδη στο υλικό",
        "addSuccess": "Η προσθήκη υλικού ήταν επιτυχής",
        "saveError": "Αποτυχία αποθήκευσης εικόνας, παρακαλούμε προσπαθήστε ξανά αργότερα！",
        "delSuccess": "Η διαγραφή ήταν επιτυχής",
        "generateImage": "Δημιουργία Εικόνας από Κείμενο",
        "generateImagePlaceholder": "Παρακαλούμε εισάγετε την εικόνα που θέλετε να δημιουργήσετε, π.χ. Μια πεταλούδα χορεύει σε ένα πεδίο λουλουδιών",
        "aiExpand": "Εξυπνή Επέκταση",
        "negativePrompt": "Αντικείμενική Προτροπή",
        "negativePromptTooltip": "Χρησιμοποιείται για την σαφή εξάλειψη περιεχομένου ή χαρακτηριστικών που ο χρήστης δεν θέλει να εμφανιστούν στην έξοδο",
        "imageRatio": "Τỷπος Εικόνας",
        "generateImageBtn": "Δημιουργία Αμέσως",
        "shengchengjieguo": "Αποτέλεσμα Δημιουργίας",
        "generateImageLoadingTip": "Γεννιέται, παρακαλούμε μην κάνετε διπλό κλικ ή κλείσετε...",
        "Tooltip": "Έλα και AI την δημιουργικότητά σου",
        "saveToMaterial": "Αποθήκευση στο Υλικό",
        "publish": "Δημοσίευση Αμέσως",
        "download": "Λήψη",
        "generateHistory": "Ιστορική Δημιουργίας",
        "hide": "Σύρσιμο",
        "cancel": "Ακύρωση",
        "useExpand": "Χρήση Επέκτασης",
        "all": "Όλες",
        "delete": "Διαγραφή",
        "loadMore": "Φόρτωση Περισσότερων",
        "aiTip": "Το περιεχόμενο δημιουργείται από μοντέλο τεχνητής νοημοσύνης και δεν αντιπροσωπεύει την άποψη, τη στάση ή την 태σισ της πλατφόρμας. Παρακαλούμε χρησιμοποιήστε το περιεχόμενο AI με λογικότητα και συμμόρφωση με το νόμο",
        "operationSuccess": "Λειτουργία Επιτυχής",
        "moveGroup": "Μετακίνηση Ομάδας",
        "groupName": "Όνομα Ομάδας",
        "pleaseSelectGroup": "Παρακαλούμε επιλέξτε το όνομα της ομάδας！",
        "shenhe": "Έλεγχος",
        "shenheStatus": "Κατάσταση Ελέγχου",
        "shenheSuccess": "Έχει περάσει τον έλεγχο",
        "shenheRefuse": "Απόρριψη Ελέγχου",
        "pleaseSelectShenheStatus": "Παρακαλούμε επιλέξτε την κατάσταση ελέγχου！",
        "shenheRemark": "Σημείωση Ελέγχου",
        "pleaseInputShenheRemark": "Παρακαλούμε εισάγετε τη σημείωση ελέγχου！",
        "pleaseInputFileName": "Παρακαλούμε εισάγετε το όνομα του αρχείου！",
        "whitespace": "Λάθος ονομασία, το όνομα του αρχείου δεν μπορεί να περιέχει κενά！",
        "dataError": "Λάθος δεδομένων！",
        "confirmDelete": "Επιβεβαίωση Διαγραφής",
        "confirm": "Επιβεβαίωση",
        "deleteFolder": "Διαγραφή Φάκελου",
        "add": "Προσθήκη",
        "edit": "Επεξεργασία",
        "fileName": "Όνομα Αρχείου",
        "group": "Ομάδα",
        "resolution": "Ανάλυση",
        "type": "Τύπος",
        "image": "Εικόνα",
        "music": "Μουσική",
        "video": "Βίντεο",
        "uploadTime": "Ώρα Ανέβασμα",
        "uploadUser": "Χρήστης Ανέβασμα",
        "checkTime": "Ώρα Ελέγχου",
        "checkUser": "Χρήστης Ελέγχου"
    },
    "setting": {
        "nameempty": "Το όνομα δεν μπορεί να είναι κενό",
        "heightempty": "Το ύψος δεν μπορεί να είναι κενό",
        "widthempty": "Το πλάτος δεν μπορεί να είναι κενό",
        "resolutionratio": "Ανάλυση",
        "name": "Όνομα",
        "opteration": "Λειτουργία",
        "compile": "Επεξεργασία",
        "delete": "Διαγραφή",
        "newz": "Νέο",
        "compileratio": "Επεξεργασία Αναλύσεων",
        "sheizhifenbianlvmingcheng": "Ρύθμιση Ονόματος Αναλύσεων",
        "shezhigaodu": "Ρύθμιση Ύψους",
        "shezhikuandu": "Ρύθμιση Πλάτους",
        "xinzengfenbianlv": "Νέα Αναλύσεις",
        "bianma": "Κωδικοποίηση",
        "bianjizhongduanmingcheng": "Επεξεργασία Ονόματος Τερματικού",
        "xinzengzhongduan": "Νέο Τερματικό",
        "selectPrimaryColor": "Επιλογή Βασικού Χρώματος Θέματος",
        "fullScreen": "Πλήρης Οθόνη",
        "exitFullScreen": "Έξοδος από Πλήρη Οθόνη"
    },
    "tabs": {
        "refresh": "Ανανέωση",
        "refreshAll": "Ανανέωση Όλων",
        "close": "Κλείσιμο",
        "closeOthers": "Κλείσιμο Άλλων",
        "closeAll": "Κλείσιμο Όλων",
        "closeLeft": "Κλείσιμο Αριστερά",
        "closeRight": "Κλείσιμο Δεξιά"
    },
    "errorPage": {
        "needLogin": "Δεν έχετε συνδεθεί ακόμα！",
        "pageNotFound": "Η σελίδα που προσπελάζετε δεν υπάρχει！",
        "redirectTo": "Ανακατεύθυνση προς",
        "orReturn": "ή επιστροφή",
        "previousStep": "Προηγούμενο Βήμα"
    },
    "headerUs": {
        "systemNotice": "Ειδοποίηση Συστήματος",
        "allNotices": "Όλες οι Ειδοποιήσεις",
        "viewAllMessages": "Εμφάνιση Όλων των Μηνυμάτων",
        "contactUs": "Επικοινωνία Με Εμάς",
        "operationSuccess": "Η λειτουργία ήταν επιτυχής！",
        "leaveMessage": "Θέλω να αφήσω ένα μήνυμα",
        "messageTitle": "Τίτλος",
        "messageTitleTip": "Παρακαλούμε εισάγετε τον τίτλο！",
        "messageContentTip": "Μέγιστο 150 χαρακτήρες",
        "submit": "Υποβολή",
        "markAsRead": "Σήμανση ως Διαβασμένο",
        "success": "Η λειτουργία ήταν επιτυχής！"
    },
    "material": {
        "allMaterial": "Όλο το Υλικό",
        "defaultGroup": "Προεπιλεγμένη Ομάδα",
        "auditStatus": "Κατάσταση Ελέγχου",
        "auditPassed": "Έχει περάσει τον έλεγχο",
        "auditRejected": "Απόρριψη Ελέγχου",
        "pendingAudit": "Σε Αναμονή Ελέγχου",
        "all": "Όλες",
        "operateSuccess": "Η λειτουργία ήταν επιτυχής！",
        "pleaseSelectMaterial": "Παρακαλούμε επιλέξτε υλικό！",
        "moveGroup": "Μετακίνηση Ομάδας",
        "pleaseSelectGroup": "Παρακαλούμε επιλέξτε ομάδα！",
        "batchPublish": "Μαζική Δημοσίευση",
        "batchRecall": "Μαζική Ανάκληση",
        "batchDelete": "Μαζική Διαγραφή",
        "materialList": "Λίστα Υλικού",
        "uploadMaterial": "Ανέβασμα Υλικού",
        "materialType": "Τύπος Υλικού",
        "pleaseInputMaterialName": "Παρακαλούμε εισάγετε το όνομα του υλικού",
        "selectAll": "Επιλογή Όλων",
        "confirmDeleteSelectedMaterial": "Επιβεβαίωση διαγραφής επιλεγμένου υλικού;",
        "deleteSuccess": "Η διαγραφή ήταν επιτυχής",
        "delete": "Διαγραφή",
        "publish": "Δημοσίευση",
        "recall": "Ανάκληση",
        "confirmRecallSelectedMaterial": "Επιβεβαίωση ανάκλησης επιλεγμένου υλικού;",
        "pleaseSelectMaterialGroup": "Παρακαλούμε επιλέξτε ομάδα υλικού！",
        "recallSuccess": "Η ανάκληση ήταν επιτυχής",
        "publishSuccess": "Η δημοσίευση ήταν επιτυχής",
        "batchOperate": "Μαζική Λειτουργία",
        "item": "αρτήματα",
        "confirmDelete": "Επιβεβαίωση Διαγραφής;",
        "edit": "Επεξεργασία",
        "confirmRecall": "Επιβεβαίωση Ανάκλησης;",
        "unaudited": "Μη Ελεγχόμενο",
        "notPassed": "Μη Επιβεβαιωμένο",
        "operate": "Λειτουργία",
        "resolution": "Ανάλυση",
        "none": "Κανένα",
        "confirm": "Επιβεβαίωση",
        "cancel": "Ακύρωση",
        "AICreation": "AI Δημιουργία"
    },
    "uploadFile": {
        "operationSuccess": "Λειτουργία Επιτυχής",
        "uploadFile": "Διαχείριση Ανέβασμα",
        "uploadSuccess": "Το ανέβασμα ήταν επιτυχής",
        "uploadCompleted": "Το ανέβασμα ολοκληρώθηκε",
        "uploadFail": "Αποτυχία Ανέβασμα",
        "ConversionFailed": "Αποτυχία Μετατροπής！",
        "loading": "Φόρτωση...",
        "beQueuing": "Σε Ουρά Αναμονής...",
        "Uploading": "Ανέβασμα...",
        "ConversionIng": "Μετατροπή...",
        "ConventionalResources": "Συμβατικές Πόροι",
        "DocumentResources": "Πόροι Εγγράφων",
        "complete": "Ολοκλήρωση",
        "upload": "Ανέβασμα",
        "fileSizeWraning01": "Το μέγεθος του υλικού υπερβαίνει",
        "fileSizeWraning02": "Παρακαλούμε τροποποιήστε και προσπαθήστε να το ανεβάσετε ξανά！",
        "fileIsEmpty": "Το αρχείο είναι κενό",
        "uploadFileTip": "Μη υποστηριζόμενο formato αρχείου",
        "unablePreview": "Δεν προστέθηκε επιτυχώς στη βιβλιοθήκη υλικού, δεν μπορεί να προεπισκοπηθεί",
        "confirmDelete": "Επιβεβαίωση Διαγραφής;",
        "deleteSuccess": "Η διαγραφή ήταν επιτυχής",
        "delete": "Διαγραφή",
        "confirm": "Επιβεβαίωση",
        "preview": "Προεπισκόπηση",
        "close": "Κλείσιμο",
        "cancel": "Ακύρωση",
        "fileType": "Τύπος Αρχείου",
        "fileSize": "Μέγεθος Αρχείου",
        "conversionProgress": "Πρόοδος Μετατροπής",
        "progress": "Πρόοδος",
        "image": "Εικόνα",
        "video": "Βίντεο",
        "audio": "Ήχος",
        "limitTip01": "Μία φορά ανέβασμα",
        "limitTip02": "αρχεία",
        "okTip": "Γίνεται ανέβασμα υλικού, παρακαλούμε κλείστε αργότερα！",
        "usableSize": "Διαθέσιμος Χώρος",
        "sizeUnableTip": "Ο τρέχων διαθέσιμος χώρος αποθήκευσης είναι ανεπαρκής, παρακαλούμε καθαρίστε τα άχρηστα υλικά από το σύστημα για να εξοικονομήσετε χώρο ή επικοινωνήστε με τον διανομέα για επέκταση του χώρου αποθήκευσης στο σύννεφο. Αυτή η υπηρεσία μπορεί να προκαλέσει έξοδα, για περισσότερες λεπτομέρειες ανατρέξτε στις πληροφορίες του διανομέα.",
        "view": "Εμφάνιση Λεπτομερειών",
        "fileName": "Όνομα Αρχείου"
    },
    "template": {
        "inputPlaceholder": "Παρακαλούμε εισάγετε",
        "selectPlaceholder": "Παρακαλούμε επιλέξτε",
        "noAuths": "Καμία δικαιώματα, παρακαλούμε επικοινωνήστε με τον διαχειριστή",
        "operationSuccess": "Λειτουργία Επιτυχής",
        "total": "Σύνολο",
        "totalNum": "αρτήματα",
        "dan": "Μονό",
        "shaung": "Διπλό",
        "pleaseSelectGroup": "Παρακαλούμε επιλέξτε ομάδα",
        "preview": "Προεπισκόπηση",
        "free": "Δωρεάν",
        "use": "Χρήση",
        "dpi": "Ανάλυση",
        "delete": "Διαγραφή",
        "confirmDelete": "Επιβεβαίωση Διαγραφής",
        "confirmDeleteSelectedTemplate": "Επιβεβαίωση διαγραφής αυτού του προτύπου",
        "push": "Δημοσίευση",
        "pushConfirm": "Επιβεβαίωση δημοσίευσης στο δημόσιο πρότυπο",
        "pushRemovalConfirm": "Επιβεβαίωση απομάκρυνσης από το δημόσιο πρότυπο",
        "templateOrderRecord": "Καταγραφή Παραγγελίας Προτύπου",
        "unpublished": "Μη Δημοσιευμένο",
        "auditing": "Σε Ελέγχο",
        "publishRejected": "Απόρριψη Δημοσίευσης",
        "publishSuccess": "Η δημοσίευση ήταν επιτυχής",
        "offShelf": "Απομάκρυνση από την półκα",
        "公共模版": "Δημόσιο Πρότυπο",
        "我的模板": "Τα Προτύπατά Μου",
        "共享记录": "Καταγραφή Κοινής Χρήσης",
        "name": "Όνομα",
        "pubdate": "Ημερομηνία Δημοσίευσης",
        "keySeachTip": "Παρακαλούμε εισάγετε λέξεις-κλειδιά",
        "allGroup": "Όλες οι Ομάδες",
        "add": "Προσθήκη",
        "edit": "Επεξεργασία",
        "programName": "Όνομα Προγράμματος",
        "selectGroup": "Επιλογή Ομάδας"
    },
    "checkManage": {
        "total": "Συνολικά",
        "totalNum": "γραμμές",
        "operationSuccess": "Η λειτουργία ήταν επιτυχής",
        "checkUserLogs": "Καταγραφές έλεγχου (τεχνικός υποστήριξης)",
        "checkLogs": "Καταγραφές έλεγχου (ελεγκτής)",
        "sourceCheck": "Έλεγχος υλικού",
        "programCheck": "Έλεγχος προγράμματος",
        "checkAll": "Επιλογή όλων",
        "auditPass": "Έλεγχος επιβεβαιώθηκε",
        "auditRefuse": "Έλεγχος απορρίφθηκε",
        "auditPass01": "Επιβεβαιώθηκε",
        "auditRefuse01": "Απορρίφθηκε",
        "auditRefuse02": "Απόρριψη ελέγχου",
        "auditor": "Ελεγκτής",
        "agentUserName": "Χρήστης δημοσίευσης",
        "interrogationTime": "Ώρα υποβολής για έλεγχο",
        "checkTime": "Ώρα ελέγχου",
        "checkName": "Όνομα ελέγχου",
        "checkType": "Κατηγορία ελέγχου",
        "checkIp": "IP διεύθυνση υποβολής για έλεγχο",
        "checkReason": "Σχόλια",
        "checkStatus": "Περιεχόμενο λειτουργίας",
        "rangePicker": "Ημερομηνία ελέγχου",
        "keyWord": "Λέξη-κλειδί",
        "all": "Όλα",
        "program": "Πρόγραμμα",
        "material": "Υλικό",
        "dan": "Μονό",
        "shaung": "Διπλό",
        "pleaseSelectProgram": "Παρακαλούμε επιλέξτε πρόγραμμα!",
        "pleaseSelectMaterial": "Παρακαλούμε επιλέξτε υλικό!",
        "preview": "Προεπισκόπηση",
        "dpi": "Ανάλυση",
        "auditRefuseTip": "Παρακαλούμε εισαγάγετε τον λόγο της απόρριψης",
        "unreviewed": "Μη ελεγχόμενο",
        "notPassed": "Μη επιβεβαιωμένο",
        "notUsed": "Μη χρησιμοποιούμενο",
        "edit": "Επεξεργασία",
        "none": "Κανένα",
        "name": "Όνομα",
        "size": "Μέγεθος",
        "type": "Τύπος",
        "uploadTime": "Ώρα ανέβασμα",
        "uploadUser": "Χρήστης που ανέβασε",
        "checkUser": "Ελεγκτής",
        "image": "Εικόνα",
        "music": "Μουσική",
        "video": "Βίντεο"
    },
    "systemSet": {
        "total": "Συνολικά",
        "totalNum": "γραμμές",
        "inputPlaceholder": "Παρακαλούμε εισαγάγετε",
        "selectPlaceholder": "Παρακαλούμε επιλέξτε",
        "userList": "Μέλη οργανισμού",
        "roleList": "Δικαιώματα ρόλου",
        "department": "Οργανωτική δομή",
        "diskInfo": "Χώρος αποθήκευσης",
        "approveSet": "Έγκριση περιεχομένου",
        "logList": "Διαχείριση καταγραφών",
        "name": "Όνομα",
        "account": "Λογαριασμός",
        "userName": "Όνομα χρήστη",
        "phoneNumber": "Τηλεφωνικός αριθμός",
        "role": "Ρόλος",
        "createTime": "Ώρα δημιουργίας",
        "operation": "Λειτουργία",
        "edit": "Επεξεργασία",
        "delete": "Διαγραφή",
        "addNew": "Προσθήκη νέου",
        "add": "Προσθήκη",
        "resetPassword": "Επαναφορά κωδικού πρόσβασης",
        "confirmDelete": "Επιβεβαίωση διαγραφής",
        "departmentOrganization": "Τμήμα/Οργανισμός",
        "addNewUser": "Προσθήκη νέου χρήστη",
        "pleaseEnterUserName": "Παρακαλούμε εισαγάγετε το όνομα του χρήστη",
        "confirmPasswordNotMatch": "Ο επιβεβαιωτικός κωδικός πρόσβασης δεν ταιριάζει με τον κωδικό πρόσβασης!",
        "operationSuccess": "Η λειτουργία ήταν επιτυχής！",
        "userNickname": "Περάσματος χρήστη",
        "pleaseEnterUserNickname": "Παρακαλούμε εισαγάγετε το περάσματος του χρήστη",
        "userNicknameRequired": "Το περάσμα του χρήστη δεν μπορεί να είναι κενό！",
        "password": "Κωδικός πρόσβασης",
        "pleaseEnterPassword": "Παρακαλούμε εισαγάγετε τον κωδικό πρόσβασης",
        "passwordRequired": "Ο κωδικός πρόσβασης δεν μπορεί να είναι κενός！",
        "passwordTip": "Η ασφάλεια του κωδικού πρόσβασής σας είναι πολύ χαμηλή (ο κωδικός πρέπει να περιέχει τυχαία 3 από τα κεφαλαία/πεζά γράμματα, αριθμούς, ειδικούς χαρακτήρες και να έχει μήκος 8)",
        "confirmPassword": "Επιβεβαίωση κωδικού πρόσβασης",
        "pleaseEnterPhoneNumber": "Παρακαλούμε εισαγάγετε τον τηλεφωνικό αριθμό",
        "phoneNumberRequired": "Ο τηλεφωνικός αριθμός δεν μπορεί να είναι κενός！",
        "phoneNumberFormatError": "Παρακαλούμε εισαγάγετε έναν έγκυρο τηλεφωνικό αριθμό！",
        "roleRequired": "Ο ρόλος δεν μπορεί να είναι κενός！",
        "required": "Δεν μπορεί να είναι κενό！",
        "departmentName": "Τμήμα",
        "modifyPassword": "Τροποποίηση κωδικού πρόσβασης",
        "newPassword": "Νέος κωδικός πρόσβασης",
        "pleaseEnterNewPassword": "Παρακαλούμε εισαγάγετε τον νέο κωδικό πρόσβασης",
        "pwdMessage": "Ο κωδικός πρόσβασης πρέπει να έχει μήκος 8~20 χαρακτήρες, να μην περιέχει κενά και να περιέχει 3 από τα κεφαλαία/πεζά γράμματα, αριθμούς, ειδικούς χαρακτήρες",
        "all": "Όλα",
        "noAuths": "Δεν υπάρχουν δικαιώματα, παρακαλούμε επικοινωνήστε με τον διαχειριστή",
        "departmentName01": "Όνομα τμήματος",
        "image": "Εικόνα",
        "music": "Μουσική",
        "video": "Βίντεο",
        "buySize": "Ποσότητα αγοράς",
        "totalMoney": "Πλήρωμη ποσού",
        "buycreateTime": "Ώρα αγοράς",
        "endTime": "Ημερομηνία λήξης",
        "buyTypeStr": "Τύπος παραγγελίας",
        "sourceCheck": "Έλεγχος υλικού",
        "programCheck": "Έλεγχος προγράμματος",
        "programName": "Όνομα προγράμματος",
        "diskExpansion": "Συνιστάται να καθαρίζετε τα παρωχημένα/μη χρησιμοποιούμενα υλικά σε regelmείς διαστήματα κατά τη χρήση, για να διασφαλιστεί η διαθέσιμη χωρητικότητα του συστήματος. Εάν χρειάζεστε μεγαλύτερο χώρο, μπορείτε να επικοινωνήσετε με τον πάροχο της συσκευής σας για να αποκτήσετε υπηρεσία επέκτασης χωρητικότητας χώρου σύννεφου αποθήκευσης. Αυτή η υπηρεσία μπορεί να προκαλέσει έξοδα, το οποίο εξαρτάται από τις πληροφορίες του αντιπρόσωπου.",
        "selectPermission": "Παρακαλούμε επιλέξτε δικαιώματα",
        "checkPermission": "Παρακαλούμε επιλέξτε τα δικαιώματα",
        "addRole": "Προσθήκη ρόλου",
        "enterRoleName": "Παρακαλούμε εισαγάγετε το όνομα του ρόλου",
        "roleName": "Όνομα ρόλου",
        "roleNameRequired": "Το όνομα του ρόλου δεν μπορεί να είναι κενό！",
        "remark": "Σημείωση",
        "enterRemark": "Παρακαλούμε εισαγάγετε τη σημείωση",
        "permissionSetting": "Ρύθμιση δικαιωμάτων",
        "deleteSuccess": "Η διαγραφή ήταν επιτυχής！",
        "confirmToDelete": "Είστε βέβαιοι ότι θέλετε να διαγράψετε？",
        "orgName": "Όνομα οργανισμού",
        "orgNameRequired": "Το όνομα του οργανισμού δεν μπορεί να είναι κενό！",
        "orgRemark": "Σημείωση οργανισμού",
        "enterOrgRemark": "Παρακαλούμε εισαγάγετε τη σημείωση του οργανισμού",
        "capacityUsage": "Κατάσταση χρήσης χωρητικότητας",
        "usedCapacity": "Χρησιμοποιημένη χωρητικότητα",
        "totalCapacity": "Συνολική χωρητικότητα",
        "remainingCapacity": "Υπόλοιπο χωρητικότητας",
        "capacityExpansion": "Επέκταση χωρητικότητας",
        "enable": "Ενεργοποίηση",
        "disable": "Απενεργοποίηση",
        "userName01": "Όνομα χρήστη",
        "loginTime": "Ώρα σύνδεσης",
        "ipAddress": "IP διεύθυνση",
        "loginResult": "Αποτέλεσμα σύνδεσης",
        "selectDate": "Επιλογή ημερομηνίας",
        "enterDate": "Παρακαλούμε επιλέξτε ημερομηνία",
        "selectStartTime": "Παρακαλούμε επιλέξτε την αρχική ώρα",
        "selectEndTime": "Παρακαλούμε επιλέξτε την τελική ώρα",
        "enterUserName": "Παρακαλούμε εισαγάγετε το όνομα του χρήστη",
        "userCount": "Αριθμός χρηστών",
        "roleDesc": "Περιγραφή ρόλου",
        "roleAuthorization": "Δικαιοποίηση ρόλου",
        "success": "Επιτυχία",
        "failure": "Αποτυχία",
        "time": "Ώρα",
        "operationContent": "Περιεχόμενο λειτουργίας",
        "playCount": "Αριθμός αναπαραγωγών",
        "playDuration": "Διάρκεια αναπαραγωγής",
        "selectDevice": "Επιλογή συσκευής",
        "enterProgramName": "Παρακαλούμε εισαγάγετε το όνομα του προγράμματος",
        "serialNumber": "Αριθμός σειράς",
        "publishContentName": "Όνομα δημοσιευμένου περιεχομένου",
        "playMode": "Τρόπος αναπαραγωγής",
        "cyclePlay": "Επαναληπτική αναπαραγωγή",
        "insertPlay": "Εισαγωγή αναπαραγωγής",
        "paddingPlay": "Προσβάθμιση αναπαραγωγής",
        "playDeviceId": "ID συσκευής αναπαραγωγής",
        "playDeviceName": "Όνομα συσκευής αναπαραγωγής",
        "publishTime": "Ώρα δημοσίευσης",
        "downloadStatus": "Κατάσταση λήψης",
        "notDownloaded": "Μη κατεβασμένο",
        "downloading": "Κατεβάζοντας",
        "downloadSucceeded": "Η λήψη ήταν επιτυχής",
        "downloadFailed": "Η λήψη απέτυχε",
        "enterPublishContentName": "Παρακαλούμε εισαγάγετε το όνομα του δημοσιευμένου περιεχομένου",
        "terminalId": "ID τερματικού",
        "belongOrg": "Αποκτάμενος οργανισμός",
        "reportTime": "Ώρα υποβολής αναφοράς",
        "reportIp": "IP υποβολής αναφοράς",
        "logInfo": "Πληροφορίες καταγραφής",
        "details": "Λεπτομέρειες",
        "confirmDeletion": "Είστε βέβαιοι ότι θέλετε να διαγράψετε？",
        "logDetails": "Λεπτομέρειες καταγραφής",
        "download": "Λήψη",
        "deptOrg": "Τμήμα/Οργανισμός",
        "query": "Ερώτηση",
        "queryByTerminalId": "Ερώτηση κατά ID τερματικού",
        "batchDeleteLogs": "Μαζική διαγραφή καταγραφών",
        "customTimeDeleteLogs": "Διαγραφή καταγραφών με προσαρμοσμένη ώρα",
        "selectTimeRangeFirst": "Παρακαλούμε πρώτα επιλέξτε το χρονικό διάστημα",
        "deleteAllDeviceLogsIfEmpty": "Εάν δεν συμπληρωθεί το ID συσκευής, θα διαγραφούν οι καταγραφές όλων των συσκευών από προεπιλογή",
        "enterDeviceIdToDeleteLogs": "Παρακαλούμε εισαγάγετε το ID της συσκευής για διαγραφή καταγραφών",
        "confirmDeleteAction": "Επιβεβαίωση διαγραφής",
        "selectDeleteRangeFirst": "Παρακαλούμε πρώτα επιλέξτε το εύρος διαγραφής",
        "networkConnectionFailed": "Η σύνδεση με το δίκτυο απέτυχε",
        "playLog": "Καταγραφή αναπαραγωγής",
        "publishLog": "Καταγραφή δημοσίευσης",
        "errorLog": "Καταγραφή σφαλμάτων",
        "operationLog": "Καταγραφή λειτουργιών",
        "fileLog": "Καταγραφή αρχείων",
        "userOperateLog": "Καταγραφή σύνδεσης"
    },
    "userManual": {
        "userManual": "Εγχειρίδιο χρήστη",
        "noData": "Δεν υπάρχουν δεδομένα"
    },
    "systemNotice": {
        "systemNotice": "Ειδοποίηση συστήματος",
        "noData": "Δεν υπάρχουν δεδομένα",
        "total": "Συνολικά",
        "totalNum": "γραμμές",
        "markAllRead": "Όλα ως αναγνωσμένα",
        "deleteAll": "Διαγραφή όλων",
        "all": "Όλα",
        "unread": "Μη αναγνωσμένο",
        "read": "Αναγνωσμένο",
        "type": "Τύπος",
        "content": "Περιεχόμενο",
        "date": "Ημερομηνία",
        "status": "Κατάσταση",
        "confirmDelete": "Είστε βέβαιοι ότι θέλετε να διαγράψετε？",
        "confirm": "Επιβεβαίωση",
        "cancel": "Ακύρωση",
        "delete": "Διαγραφή"
    }
};